import React from "react";
import PropTypes from "prop-types";

import "./style.scss";

export function Screen(props) {
  const [hover, setHover] = React.useState(false);
  const [focus, setFocus] = React.useState(false);

  const onMouseEnter = () => {
    !focus && setHover(true);
  };
  const onMouseLeave = () => {
    !focus && setHover(false);
  };

  const onFocus = () => {
    setFocus(true);
    setHover(true);
  };

  const onBlur = () => {
    setFocus(false);
    setHover(false);
  };

  const [height] = React.useState(0);
  const [width] = React.useState(0);

  const renderHoverOverlay = () => (
    <div
      className="timer_screen_overlay__hover"
      style={{ height: height, width: width }}
    />
  );
  const renderFocusOverlay = () => (
    <div
      className="timer_screen_overlay__focus"
      style={{ height: height - 4, width: width - 4 }}
    />
  );

  return (
    <div
      className={`timer_screen ${props.className}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      aria-label={props.ariaLabel}
    >
      {hover && renderHoverOverlay()}
      {focus && renderFocusOverlay()}
      {props.children}
    </div>
  );
}

Screen.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components passed to screen
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  /**
   * image src for screen background
   */
  imageSrc: PropTypes.string,
};

Screen.defaultProps = {
  className: "",
};
